import React from 'react';

interface ProductDetailLayoutProps {
  sidebar: React.ReactNode;
  content: React.ReactNode;
}

export const ProductDetailLayout: React.FC<ProductDetailLayoutProps> = ({ sidebar, content }) => {
  return (
    <div className="flex flex-col gap-6 lg:flex-row">
      {/* Info sidebar (25% width on desktop) */}
      <div className="order-2 w-full lg:order-1 lg:w-1/4">{sidebar}</div>

      {/* Main content (75% width on desktop) */}
      <div className="order-1 w-full lg:order-2 lg:w-3/4">{content}</div>
    </div>
  );
};
